import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState('loading'); // loading, success, failed
  const [errorMessage, setErrorMessage] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('/pricing'); // 기본값으로 pricing 페이지 설정

  useEffect(() => {
    const processPayment = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const authKey = searchParams.get('authKey');
      const order_id = searchParams.get('order_id');
      const customerKey = searchParams.get('customerKey');

      if (!authKey || !order_id) {
        setPaymentStatus('failed');
        return;
      }

      try {
        // 빌링키 발급 및 최초 결제 요청
        const response = await api.post('payments/cards/success/', {
          auth_key: authKey,
          order_id: order_id,
        });

        if (response.data.success) {
          setPaymentStatus('success');
        } else {
          setPaymentStatus('failed');
          setErrorMessage(response.data.message || '알 수 없는 오류로 결제에 실패했습니다.');
        }
      } catch (error) {
        console.error('결제 처리 실패:', error);
        // 2. API 요청 실패(catch) 시 에러 메시지 저장
        let msg = '알 수 없는 오류로 결제에 실패했습니다.';
        if (error.response?.data?.message) {
          msg = error.response.data.message;
        }
        setErrorMessage(msg);
        setPaymentStatus('failed');

        try {
          await api.delete('payments/cards/request/', {
            data: {
              customer_key: customerKey
            }
          });
        } catch (cancelError) {
          console.error('정기 결제 상태 변경 실패:', cancelError);
        }
      }
    };

    processPayment();
  }, []);

  const renderContent = () => {
    switch (paymentStatus) {
      case 'loading':
        return (
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
            <p className="text-lg text-gray-600">결제를 처리중입니다...</p>
          </div>
        );

      case 'success':
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">결제가 완료되었습니다!</h2>
            <p className="text-lg text-gray-600 mb-8">이제 서비스를 이용하실 수 있습니다.</p>
            <button
              onClick={() => window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/workspaces`}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
              공간으로 이동
            </button>
          </div>
        );

      case 'failed':
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">결제에 실패했습니다</h2>
            <p className="text-lg text-gray-600 mb-8">다시 시도해주세요.</p>
            {/* 3. UI에 실패 사유 표시 */}
            {errorMessage && (
                <div className="text-left bg-red-50 border border-red-200 p-4 rounded-lg my-6">
                    <p className="text-sm text-red-800">
                        <span className="font-semibold">실패 사유:</span> {errorMessage}
                    </p>
                </div>
            )}
            
            <div className="space-x-4">
              <button
                onClick={() => navigate(redirectUrl)}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
              >
                요금제 선택으로 돌아가기
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        {renderContent()}
      </div>
    </div>
  );
};

export default SuccessPage;